// Single source of truth for "what counts as a public / pre-auth path."
// /auth/* are the OIDC redirect handlers (would deadlock if signinRedirect
// bounced back to them). Mission Control has no anonymous product surface.
export const PUBLIC_PATH_PREFIXES = ['/auth/'];

export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
